import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_lista.css';
import _ from 'lodash';

class Lista extends Component {

    renderData() {
        const { data, renderItem } = this.props;
        return _.map(data, (item, index) => {
            // return <span key={index}>{renderItem(item, index)}</span>
            return renderItem(item, index);
        })
    }

    render() {
        return (
            <ul ref={this.props.listRef}>
                {this.renderData()}
            </ul>
        );
    }
}

Lista.propTypes = {
    data: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
    listRef: PropTypes.func
}

export default Lista;


// WEBPACK FOOTER //
// ./src/components/lista/Lista.js